export default "__VITE_ASSET__BuM5V2Y5__"